import * as React from 'react';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import { renderIdType, renderProductType } from '../../../utils/function/Function';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Color from '../../../layouts/Color';

const containerStyle = { padding: 2, ml: "-12px" };
const cardStyle = { maxWidth: 345};
const paddingStyle = { padding: 2 };

export default function PreviousInformation(props) {

    const renderContentOfPreviousInformation = (step0Data, step1Data, step2Data) => {
        return step0Data.phone !== null && step1Data.eKycFrontResponse !== null && step2Data.productCode !== null ? (
            <Grid container spacing={3} sx={paddingStyle}>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> ID type: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {renderIdType(step0Data.idType)} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> No: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step1Data.eKycFrontResponse.id} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Name: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step1Data.eKycFrontResponse.name} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Gender: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step1Data.eKycFrontResponse.sex} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> DOB: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}>  {props.step1Data.eKycFrontResponse.dob} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}>  Nationality: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step1Data.eKycFrontResponse.nationality} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Address: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step1Data.eKycFrontResponse.address} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Phone: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step0Data.phone} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Email: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step0Data.email} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Product Type: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {renderProductType(step2Data.productType)} </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                    <Typography variant="body3" color={Color.Normal}> Product: </Typography>
                </Grid>
                <Grid item xs={8} sm={8}>
                    <Typography variant="body3" color={Color.Normal}> {step2Data.productName} </Typography>
                </Grid>
            </Grid>) : (<Grid container spacing={3} sx={paddingStyle}>
               
            </Grid>);
    }

    return (
        <React.Fragment>
            <Grid container spacing={3} sx={containerStyle}>
                <Card sx={cardStyle}>
                    {renderContentOfPreviousInformation(props.step0Data, props.step1Data, props.step2Data)}
                </Card>
            </Grid>
        </React.Fragment>
    );
}